import type { Me } from "./session";

/** The companies a staff member can open the console in. */
export const adminCompanies = (me: Me) => me.companies.filter((c) => c.apps.includes("admin"));

const AUTH_PAGES = ["/sign-in", "/set-password", "/choose-company"];

/**
 * A `next` path is only followed inside the console: a relative path, not protocol-relative
 * ("//evil.example"), and not back to a sign-in step.
 */
export function safeNext(next: string | undefined): string | undefined {
  if (!next?.startsWith("/") || next.startsWith("//") || next.startsWith("/\\")) return undefined;
  const path = next.split(/[?#]/)[0];
  return AUTH_PAGES.includes(path) ? undefined : next;
}

/**
 * Staff whose roles grant no permission at all, such as an investor viewer (P15-23): nothing in
 * the console is theirs. Their access is the assistant's investor page, which every staff member
 * may open.
 */
export const nothingInConsole = (me: Me) => me.permissions.length === 0;

/** Where nothing-in-the-console staff are sent instead of an empty console. */
export const ASSISTANT_ACCESS = "/assistant-access";

/** Where a session goes: sign in, choose a company, or the page it asked for. */
export function landingFor(me: Me | null, next?: string): string {
  const target = safeNext(next);
  if (!me) return "/sign-in";
  // the page asked for still opens once a company is chosen
  if (!me.active_company)
    return target ? `/choose-company?${new URLSearchParams({ next: target })}` : "/choose-company";
  if (nothingInConsole(me)) return ASSISTANT_ACCESS;
  return target ?? "/";
}
